<template>
    <div>
        <div class="sortingcenter">
            <div class="bg-white pl32 pr32">
                <a-tabs v-model="activeKey" @change="callback">
                    <a-tab-pane
                        v-for="(item,index) in tabList"
                        :key="index" 
                        :tab="item"
                    >
                    <div class="bg-white sortingcenter-data pt16 pb32 mb32">
                        <div class="sortingcenter-data-title">
                            <h4 class="title">
                                <div></div>
                                数据概览
                            </h4>
                            <div class="search">
                                <div class="time">
                                    <span class="mr16">交易时间</span>
                                    <a-range-picker v-model="dataForm.dataTime" :default-value="dataForm.dataDefaultTime" />
                                </div>
                                <div class="ml16">
                                    <a-button type="primary" @click="dataSearch">查询 </a-button>
                                </div>
                            </div>
                        </div>
                        <div class="sortingcenter-data-content">
                            <div class="sortingcenter-data-content-item">
                                <div class="item">
                                    <div class="name">总计回收重量</div>
                                    <div class="data">{{ overviewData.weight }} kg</div>
                                </div>
                            </div>
                            <div class="sortingcenter-data-content-item">
                                <div class="item" v-for="(item, index) in overviewData.group" :key="index">
                                    <div class="name">{{ item.parent_name }}(kg)</div>
                                    <div class="data">{{ item.weight }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-white sortingcenter-list pt32">
                        <h4 class="sortingcenter-list-title">
                            <div></div>
                            分拣中心回收订单
                        </h4>
                        <table class="wh-form wh-form_full mt16">
                            <tbody>
                                <tr>
                                    <td width="100">分拣中心：</td>
                                    <td>
                                        <a-select v-model="form.sorting_id" placeholder="请选择">
                                            <a-select-option :value="item.id" v-for="item in sortCenterList" :key="item.id">{{
                                                item.name }}
                                            </a-select-option>
                                        </a-select>
                                    </td>
                                    <td width="100">资源品类：</td>
                                    <td>
                                        <a-select v-model="form.parent_id" placeholder="请选择">
                                            <a-select-option :value="item.id" v-for="item in categoryList" :key="item.id">{{
                                                item.name }}
                                            </a-select-option>
                                        </a-select>
                                    </td>
                                    <td width="100">交易时间：</td>
                                    <td>
                                        <a-range-picker v-model="form.listTime" />
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-center" colspan="6">
                                        <a-button @click="reset" class="mr8">重 置 </a-button>
                                        <a-button type="primary" @click="search">查 询 </a-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <!-- <div class="sortingcenter-list-search mt16 mb16">
                            <div class="sortingcenter-list-search-btn">
                                <a-button type="primary" class="mr8" @click="setExportList">导 出</a-button>
                                <a-button class="" @click="
                                    getExportList();
                                visible = true;
                                                ">导出任务列表</a-button>
                            </div>
                        </div> -->
                        <a-table :columns="columns" :dataSource="backEndList" :rowKey="(record) => record.id" bordered class="mt24"
                            :pagination="pagination" @change="pageChange">
                            <template slot="abnorType" slot-scope="text">
                                <span>{{ text * 1 == 1 ? "通过" : "不通过" }}</span>
                            </template>
                            <template slot="govAbnorType" slot-scope="text">
                                <span>{{ text | govCharge }}</span>
                            </template>
                            <template slot="operation" slot-scope="text, record">
                                <a class="btn btn_text" @click="detailsClick(text)">查看详情</a>
                                <a class="btn btn_text" @click="detailsClick(text,'审核')" v-if="text.gov_abnor_type == 1">审核</a>
                            </template>
                        </a-table>
                        <a-modal :visible="visible" @ok="handleOk" :confirmLoading="confirmLoading" @cancel="handleCancel"
                            :width="modalWidth">
                            <template slot="title"><span class="orderSortingList-title">数据导出任务列表</span>
                            </template>
                            <div>
                                <a-table :columns="exportColumns" :dataSource="exportList" bordered class="mt16"
                                    :pagination="exportPagination" @change="exportChange">
                                    <template slot="createdTime" slot-scope="text">
                                        {{ $moment.unix(text).format("YYYY-MM-DD HH:mm") }}
                                    </template>
                                    <template slot="status" slot-scope="text">
                                        <i class="exportStatusIcon" :class="
                                            text != 1
                                                ? text == 2
                                                    ? 'exportStatusIconBlue'
                                                    : 'exportStatusIconsucc'
                                                : ''
                                        "></i>{{ text == 1 ? "未开始" : text == 2 ? "导出中" : "已完成" }}
                                    </template>
                                    <template slot="operation" slot-scope="text, record">
                                        <a class="btn btn_text" v-if="text.status == 3" @click="download(text.path)">下 载</a>
                                        <a @click="cancel(text.id)" class="btn btn_text" v-else>取 消</a>
                                    </template>
                                </a-table>
                            </div>
                        </a-modal>
                    </div>
                    </a-tab-pane>
                </a-tabs>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "sortingcenter",
    data() {
        return {
            form: {
                gov_abnor_type: 2
            },
            dataForm: {},
            overviewData: {},
            priceForm: this.$form.createForm(this),
            columns: [
                {
                    title: "交易时间",
                    dataIndex: "updated_at",
                    key: "updated_at",
                },
                {
                    title: "回收人员",
                    dataIndex: "recycling_name",
                    key: "recycling_name",
                },
                {
                    title: "资源品类",
                    dataIndex: "parent_name",
                    key: "parent_name",
                },
                {
                    title: "资源重量(kg)",
                    dataIndex: "real_weight",
                    key: "real_weight",
                },
                {
                    title: "手机号",
                    dataIndex: "recycling_phone",
                    key: "recycling_phone",
                },
                {
                    title: "分拣中心",
                    dataIndex: "sorting_name",
                    key: "sorting_name",
                },
                {
                    title: "家宝兔审核状态",
                    dataIndex: "abnor_type",
                    scopedSlots: { customRender: "abnorType" },
                },
                {
                    title: "城管审核状态",
                    dataIndex: "gov_abnor_type",
                    scopedSlots: { customRender: "govAbnorType" },
                },
                {
                    title: "操作",
                    dataIndex: "",
                    scopedSlots: { customRender: "operation" },
                    width:120
                },
            ],
            exportColumns: [
                {
                    title: "任务名称",
                    dataIndex: "name",
                },
                {
                    title: "创建时间",
                    dataIndex: "created_at",
                    scopedSlots: { customRender: "createdTime" },
                },
                {
                    title: "状态",
                    dataIndex: "status",
                    scopedSlots: { customRender: "status" },
                },
                {
                    title: "操作",
                    dataIndex: "",
                    scopedSlots: { customRender: "operation" },
                },
            ],
            backEndList: [],
            sortCenterList: [],
            categoryList: [],
            pagination: {
                //默认当前页
                defaultCurrent: 1,
                defaultPageSize: 10,
                showTotal() {
                    return `共 ${this.total} 条数据`;
                },
                showSizeChanger: true,
                total: 0,
            },
            page: 1,
            page_num: 10,
            exportPagination: {
                defaultCurrent: 1,
                defaultPageSize: 6,
                pageSizeOptions: ["6", "10", "15"],
                showTotal() {
                    return `共 ${this.total} 条数据`;
                },
                showSizeChanger: true,
                total: 0,
            },
            visible: false,
            confirmLoading: false,
            modalWidth: 800,
            exportPage: 1,
            exportPage_num: 10,
            exportList: [],
            tabList: ["已审核","待审核"],
            activeKey: 0
        };
    },
    created() {
        if(sessionStorage.tongluSearchData){
            let form = JSON.parse(sessionStorage.tongluSearchData)
            this.page = form.page;
            this.page_num = form.page_num;
            this.form = form;
            if(form.listTime){
                this.form.listTime = [this.$moment(form.listTime[0]),this.$moment(form.listTime[1])];
            }
            
            console.log(this.form)
            if(form.tabKey == 0){
                this.form.gov_abnor_type = 2;
                this.activeKey = 0;
            }else{
                this.form.gov_abnor_type = 1;
                this.activeKey = 1;
            }
            this.$set(this.pagination, "current", form.page);
            this.$set(this.pagination, "pageSize", form.page_num);
        }
        
        let nowTime = new Date().getTime();
        /**
         * 获取当前时间前三个月的时间
         * 另一种写法 this.$moment().subtract(1, 'quarters');
         **/
        this.dataForm.dataDefaultTime = [
            this.$moment(nowTime).subtract(3, "months"),
            this.$moment(nowTime),
        ];
        if (this.$route.query.tonglu) {
            setTimeout(() => {
                if (this.dataForm.dataDefaultTime.length) {
                    this.getOverviewList();
                }
                this.getbackEndList();
                this.getCategoryList();
                this.getSortingList();
            }, 500);
        } else {
            if (this.dataForm.dataDefaultTime.length) {
                this.getOverviewList();
            }
            this.getbackEndList();
            this.getCategoryList();
            this.getSortingList();
        }
        
    },
    components: {},
    mounted() { },
    methods: {
        // 桐庐分拣中心 --> 查看详情
        detailsClick(row,str) {
            console.log(row)
            let form = this.$utils.deepClone(this.form);
            form.page_num = this.page_num;
            form.page = this.page;
            if(this.form.gov_abnor_type == 2){
                form.tabKey = 0;
            }else{
                form.tabKey = 1;
            }
            sessionStorage.tongluSearchData = JSON.stringify(form);
            this.$router.push({
                name: "accountDetails",
                query: {
                    orderId: row.orderId,
                    orderType: row.orderType,
                    str: str
                },
            });
        },
        // 头部数据重置
        reset() {
            this.page = 1;
            this.page_num = 10;
            this.$set(this.pagination, "current", 1);
            this.$set(this.pagination, "pageSize", 10);
            if(this.activeKey == 0){
                this.form = {
                    gov_abnor_type: 2
                };
            }else{
                this.form = {
                    gov_abnor_type: 1
                };
            }
            
            this.getbackEndList();
        },
        //查询
        search() {
            this.$set(this.pagination, "current", 1);
            this.$set(this.pagination, "pageSize", 10);
            this.page = 1;
            this.page_num = 10;
            this.getbackEndList(true);
        },
        // 数据查询
        dataSearch() {
            this.getOverviewList(true);
        },
        // tab切换
        callback(e) {
            this.page = 1;
            this.page_num = 10;
            this.$set(this.pagination, "current", 1);
            this.$set(this.pagination, "pageSize", 10);
            if(e == 0){
                this.form.gov_abnor_type = 2;
            }else{
                this.form.gov_abnor_type = 1;
            }
            this.getOverviewList();
            this.getbackEndList();
        },
        // 获取 大类列表
        getCategoryList() {
            this.$api.account
                .parentCategory("", {
                    params: {
                        status: 1,
                    },
                })
                .then((res) => {
                    this.categoryList = res.data.list;
                });
        },
        // 获取分拣中心列表
        getSortingList() {
            this.$api.account.sortingList().then((res) => {
                this.sortCenterList = res.data.list;
            });
        },
        //获得获取订单列表
        //page:页 page_num每页条数
        getbackEndList(status = false) {
            this.form.page = this.page;
            this.form.limit = this.page_num;
            let date = this.form.listTime;
            if (date && date.length) {
                this.form.start_time = parseInt(
                    this.$moment(date[0]).hour(0).minute(0).second(0).valueOf() / 1000
                );
                this.form.end_time = parseInt(
                    this.$moment(date[1]).hour(23).minute(59).second(59).valueOf() / 1000
                );
            }
            let form = {
                page: this.page,
                limit: this.page_num,
                sorting_id: this.form.sorting_id,
                parent_id: this.form.parent_id,
                start_time: this.form.start_time,
                end_time: this.form.end_time,
                gov_abnor_type: this.form.gov_abnor_type
            };

            this.$api.account.backEndList(form).then((res) => {
                this.pagination.total = res.total * 1;
                res.data.list.forEach((el, index) => {
                    el.id = index;
                    if(el.real_weight * 1 < 0){
                        el.real_weight = 0;
                    }
                });
                this.backEndList = res.data.list;
                status ? this.$message.success("共查询到" + res.total + "条信息") : "";
            });
        },
        // 获取数据概览
        getOverviewList(status = false) {
            let dataJson = {};
            let date = this.dataForm.dataTime;
            if (date && date.length) {
                dataJson.start_time = parseInt(
                    this.$moment(date[0]).hour(0).minute(0).second(0).valueOf() / 1000
                );
                dataJson.end_time = parseInt(
                    this.$moment(date[1]).hour(23).minute(59).second(59).valueOf() / 1000
                );
            } else {
                dataJson.start_time = parseInt(
                    this.$moment(this.dataForm.dataDefaultTime[0])
                        .hour(0)
                        .minute(0)
                        .second(0)
                        .valueOf() / 1000
                );
                dataJson.end_time = parseInt(
                    this.$moment(this.dataForm.dataDefaultTime[1])
                        .hour(23)
                        .minute(59)
                        .second(59)
                        .valueOf() / 1000
                );
            }
            dataJson.gov_abnor_type = this.form.gov_abnor_type;
            this.$api.account.overviewList(dataJson).then((res) => {
                this.overviewData = res.data;
                status ? this.$message.success(res.msg) : "";
            });
        },
        //加入导出列表
        setExportList() {
            let form = this.$utils.deepClone(this.form);
            let date = this.form.listTime;
            let formData = form;
            if (date && date.length > 0) {
                formData.start_time = parseInt(
                    this.$moment(date[0]).hour(0).minute(0).second(0).valueOf() / 1000
                );
                formData.end_time = parseInt(
                    this.$moment(date[1]).hour(23).minute(59).second(59).valueOf() / 1000
                );
            } else {
                delete formData["start_time"];
                delete formData["end_time"];
            }
            formData.limit = this.page_num;
            formData.page = this.page;
            delete formData.listTime;
            this.$api.account.backStartTask(formData).then((res) => {
                this.$message.success("成功加入导出任务列表!");
            });
        },
        // 弹框-数据导出任务列表确认按钮
        handleOk(e) {
            this.visible = false;
        },
        // 弹框-数据导出任务列表取消按钮
        handleCancel(e) {
            this.visible = false;
        },
        //获得导出任务列表
        getExportList() {
            let s = {};
            s.page = this.exportPage;
            s.page_num = this.exportPage_num;
            s.excel_type = 47;
            this.$api.common.excelList(s).then((res) => {
                this.exportPagination.total = res.total * 1;
                this.exportList = res.data.list;
            });
        },
        //下载任务
        download(path) {
            window.open(path);
        },
        //取消下载任务
        cancel(id) {
            this.$http;
            this.$api.common.deleteExcel({ id: id }).then((res) => {
                this.$message.success("取消下载任务成功！");
                this.getExportList();
            });
        },
        //导出任务列表分页
        exportChange(pagination) {
            this.$set(this.exportPagination, "current", pagination.current);
            this.$set(this.exportPagination, "pageSize", pagination.pageSize);
            this.exportPage = pagination.current;
            this.exportPage_num = pagination.pageSize;
            this.getExportList();
        },
        // 分页
        pageChange(pagination) {
            this.$set(this.pagination, "current", pagination.current);
            this.$set(this.pagination, "pageSize", pagination.pageSize);
            this.page = pagination.current;
            this.page_num = pagination.pageSize;
            this.getbackEndList();
        },
    },
    watch: {

    },
};
</script>
<style rel="stylesheet/scss" lang="scss">
.sortingcenter {
    &-data {
        &-title {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .title {
                display: flex;
                align-items: center;
                color: $title-color-black-85;
                @include pxAndLh(16);
                font-weight: bold;
                margin: 0;

                &>div {
                    width: 5px;
                    height: 20px;
                    background: linear-gradient(180deg, #3f94ec 0%, #0c6ecf 100%);
                    border-radius: 5px;
                    margin-right: 5px;
                }
            }

            .search {
                display: flex;
                align-items: center;
            }
        }

        &-content {
            &-item {
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                font-size: 14px;

                .item {
                    margin-right: 70px;
                    margin-top: 10px;

                    .name {
                        color: #858a90;
                    }

                    .data {
                        color: #363e51;
                        font-weight: 600;
                    }

                    &>div {
                        text-align: center;
                    }
                }
            }
        }
    }

    &-list {
        &-title {
            display: flex;
            align-items: center;
            color: $title-color-black-85;
            @include pxAndLh(16);
            font-weight: bold;
            margin: 0;

            &>div {
                width: 5px;
                height: 20px;
                background: linear-gradient(180deg, #3f94ec 0%, #0c6ecf 100%);
                border-radius: 5px;
                margin-right: 5px;
            }
        }

        &-search {
            display: flex;
        }
    }
}
</style>